export default __webpack_public_path__ + "assets/favicon/S_favicon_active.e2e17f64.ico";